import React from 'react'

export default function AnnouncementBar(props) {
  return (
    <div className="announcement-bar">{props.message}</div>
  )
}
